import React from 'react';
import { motion } from 'framer-motion';
const technologies = {
  marketing: ['Meta Ads', 'Google Ads', 'Google Analytics', 'Shopify', 'WooCommerce', 'Prestashop'],
  tech: ['React', 'TypeScript', 'AWS', 'GCP', 'OVH', 'Docker', 'Kubernetes', 'WordPress']
};
export function TechStack() {
  return <section className="py-40 bg-white relative" data-id="element-126">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" data-id="element-127" />

      <div className="max-w-6xl mx-auto px-6" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-129">
          <h2 className="text-6xl md:text-7xl font-black text-black mb-6 tracking-tight" data-id="element-130">
            Technologies & Outils
          </h2>
          <p className="text-xl text-gray-600 font-light" data-id="element-131">
            Stack marketing et technique de pointe
          </p>
        </motion.div>

        <div className="space-y-16" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-133">
            <h3 className="text-2xl font-bold text-black mb-8 text-center tracking-tight" data-id="element-134">
              Marketing & E-commerce
            </h3>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-135">
              {technologies.marketing.map((tech, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.05,
              ease: [0.16, 1, 0.3, 1]
            }} className="px-7 py-4 bg-gray-100 text-gray-800 font-medium border border-gray-200 transition-all duration-300 hover:bg-white hover:border-gray-300 hover:shadow-md" data-id="element-136">
                  {tech}
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-137">
            <h3 className="text-2xl font-bold text-black mb-8 text-center tracking-tight" data-id="element-138">
              Infrastructure & Développement
            </h3>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-139">
              {technologies.tech.map((tech, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.05,
              ease: [0.16, 1, 0.3, 1]
            }} className="px-7 py-4 bg-gray-100 text-gray-800 font-medium border border-gray-200 transition-all duration-300 hover:bg-white hover:border-gray-300 hover:shadow-md" data-id="element-140">
                  {tech}
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}